import React from "react";
import { SITE, WHATSAPP_LINK, EMAIL_LINK } from "../lib/site-data";
import { MessageCircle, Mail, CheckCircle2, Users } from "lucide-react";

export default function Hero() {
  const heroImage = "/illustrations/hero-class.png";

  return (
    <section
      id="top"
      className="relative pt-20 pb-20 lg:pt-28 lg:pb-32 bg-[#FAFAFA]"
      data-testid="hero-section"
    >
      <div className="absolute inset-0 grain opacity-60 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-6 fade-up">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white border border-[#E2E8F0] text-xs sm:text-sm text-[#1E3A8A] font-medium mb-6">
              <span className="w-2 h-2 rounded-full bg-[#D97706]" />
              Now enrolling Primary 3 · 4 · 5 · 6
            </div>

            <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-[#1E3A8A] leading-[1.05]">
              Small classes.
              <br />
              <span className="text-[#0F172A]">Big growth.</span>
            </h1>

            <p className="mt-6 text-base sm:text-lg leading-relaxed text-[#475569] max-w-xl">
              {SITE.name} is a focused tuition centre for{" "}
              <span className="text-[#0F172A] font-medium">
                Primary 3 to 6 English & Mathematics
              </span>
              . Capped at 10 students per class, with customised feedback and
              curated notes — so every child is seen, supported, and stretched.
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <a
                href={WHATSAPP_LINK(
                  `Hi ${SITE.name}, I would like to sign up my child for tuition.`
                )}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-[#1E3A8A] text-white hover:bg-[#1E40AF] px-7 py-3.5 rounded-full font-medium transition-all shadow-md hover:shadow-lg"
                data-testid="hero-whatsapp-cta"
              >
                <MessageCircle className="w-5 h-5" />
                Sign up via WhatsApp
              </a>
              <a
                href={EMAIL_LINK(
                  "Tuition Enrolment Enquiry",
                  `Hi ${SITE.name},\n\nI would like to sign up my child for tuition.\n\nChild's name:\nPrimary level:\nSubject(s):\nPreferred slot:\n\nThanks.`
                )}
                className="inline-flex items-center justify-center gap-2 border border-[#1E3A8A] text-[#1E3A8A] hover:bg-[#1E3A8A] hover:text-white px-7 py-3.5 rounded-full font-medium transition-all"
                data-testid="hero-email-cta"
              >
                <Mail className="w-5 h-5" />
                Sign up via Email
              </a>
            </div>

            <div className="mt-10 flex flex-wrap gap-x-6 gap-y-3 text-sm text-[#475569]">
              <span className="inline-flex items-center gap-2" data-testid="hero-trust-1">
                <CheckCircle2 className="w-4 h-4 text-[#1E3A8A]" />
                No registration fee
              </span>
              <span className="inline-flex items-center gap-2" data-testid="hero-trust-2">
                <CheckCircle2 className="w-4 h-4 text-[#1E3A8A]" />
                No deposit
              </span>
              <span className="inline-flex items-center gap-2" data-testid="hero-trust-3">
                <CheckCircle2 className="w-4 h-4 text-[#1E3A8A]" />
                No material fee
              </span>
            </div>
          </div>

          <div className="lg:col-span-6 fade-up fade-up-delay-2">
            <div className="relative">
              <div className="absolute -inset-4 bg-[#1E3A8A]/5 rounded-[2rem] blur-2xl" />
              <img
                src={heroImage}
                alt="Cartoon illustration of a small-group tuition class with a tutor and four primary school students"
                className="relative w-full h-[420px] sm:h-[500px] object-contain rounded-3xl shadow-xl ring-1 ring-[#E2E8F0] bg-white p-2 sm:p-3"
                data-testid="hero-image"
              />
              <div
                className="absolute -bottom-6 -left-6 bg-white rounded-2xl shadow-lg border border-[#E2E8F0] p-5 hidden sm:flex items-center gap-4"
                data-testid="hero-stat-card"
              >
                <div className="w-12 h-12 rounded-full bg-[#1E3A8A]/10 flex items-center justify-center">
                  <Users className="w-6 h-6 text-[#1E3A8A]" />
                </div>
                <div>
                  <div className="font-heading text-2xl font-bold text-[#1E3A8A]">
                    Max 10
                  </div>
                  <div className="text-xs text-[#475569]">students per class</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
